import ApiClient from '../ApiClient';

class RedlabCallsChannel extends ApiClient {
  constructor() {
    super('channels/redlab_calls_channel', { accountScoped: true });
  }
}

export default new RedlabCallsChannel();
